export default __webpack_public_path__ + "static/media/land_type_plains.558afd3e.jpg";